import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

function getTenantSlug() {
  const parts = window.location.pathname.split('/').filter(Boolean);
  if (!parts.length || parts[0] === 'superadmin') return null;
  return parts[0];
}

api.interceptors.request.use((config) => {
  const slug = getTenantSlug();
  const isSuperAdmin = window.location.pathname.startsWith('/superadmin');

  if (isSuperAdmin) {
    const saToken = localStorage.getItem('turismo_sa_token');
    if (saToken) config.headers['Authorization'] = `Bearer ${saToken}`;
  } else {
    if (slug) config.headers['X-Tenant-Slug'] = slug;
    const token = localStorage.getItem('turismo_token');
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const isSuperAdmin = window.location.pathname.startsWith('/superadmin');
      if (isSuperAdmin) {
        localStorage.removeItem('turismo_sa_token');
        localStorage.removeItem('turismo_sa_user');
        window.location.href = '/superadmin/login';
      } else {
        const slug = getTenantSlug();
        localStorage.removeItem('turismo_token');
        localStorage.removeItem('turismo_user');
        if (slug) window.location.href = `/${slug}/login`;
      }
    }
    return Promise.reject(err);
  }
);

export default api;
